import React, { useEffect, useState } from "react";
import styles from "./Style.module.css";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { renderCountryContact } from "../../../libs/redux-material.utils";
import parsePhoneNumber from "libphonenumber-js";
import { ButtonBase } from "@material-ui/core";
import EventEmitter from "../../../libs/Events.utils";
import DashboardSnackbar from "../../../components/Snackbar.component";
import { serviceRequestOtp } from "../../../services/index.services";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";

const validate = (values) => {
  const errors = {};
  const requiredFields = ["contact"];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });
  if (values.contact) {
    const phoneNumber = parsePhoneNumber(values.contact);
    if (phoneNumber) {
      if (phoneNumber.length < 7) {
        errors.contact = "Invalid Number";
      }
    } else {
      errors.contact = "Invalid Number";
    }
  }
  return errors;
};

const LoginView = (props) => {
  const { handleSubmit, country_code } = props;
  const [contactValue, setContactValue] = useState("");
  const [disable, setDisable] = useState(true);

  const _handleContactChange = (event) => {
    setContactValue(event.target.value);
  };
 
  useEffect(() => {
  //   const temp = contactValue?.split(" ");
  // let tempContact= temp[1]?.replace("-","");
     const tempContact = contactValue.replace(/^\+\d+\s/, '').replace(/\D/g, '');

    if (tempContact?.length >= 10) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [contactValue, disable]);

  const _handleSubmit = async (data) => {
    let tempContact = data.contact.split(" ");
    let temp = tempContact[1].replace("-", "");
    const modifiedContact = data?.contact.replace(/[+-]/g, "");
    const request = await serviceRequestOtp({ contact: modifiedContact });
    if (!request.error) {
      props.handleLogin(temp, tempContact[0]);
    } else {
      EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
        error: request.message,
        type: "error",
      });
      SnackbarUtils.error(request?.message);
    }
  };
  const _handleLoginPassword = () => {
    historyUtils.push("login");
  };

  return (
    <div>
      <form onSubmit={handleSubmit(_handleSubmit)}>
        <div className={styles.loginFormData}>
          <span className={styles.headingText}>Login</span>
          <div className={styles.newLine} />
        </div>
        <br />
        <div className={styles.des}>Enter your phone number to receive OTP</div>
        <div>
          <Field
            fullWidth={true}
            name="contact"
            component={renderCountryContact}
            margin={"dense"}
            country_code={"IN"}
            label="Enter your Mobile Number"
            // errorText="Required"
        
            onChange={_handleContactChange}
          />
        </div>
        <br />
        <br />
        <div className={"text-center"}>
          {!disable ? (
            <ButtonBase className={styles.sendOTPBtn} type={"submit"}>
              Send OTP
            </ButtonBase>
          ) : (
            <ButtonBase className={styles.sendOTPBtnDisable}>
              Send OTP
            </ButtonBase>
          )}
        </div>
        <br />
        <br />
        <div className={styles.bottomSignUp}>
          <ButtonBase
            onClick={_handleLoginPassword}
            className={styles.forgotBtn}
          >
            Alternately Login with password{" "}
          </ButtonBase>
        </div>
      </form>
      <DashboardSnackbar />
    </div>
  );
};

const temp = reduxForm({
  form: "login",
  validate,
})(LoginView);

function mapStateToProps(state) {
  return {
    is_authenticated: state.auth.is_authenticated,
    country_code: state.auth.country_code,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(temp);
